import React from 'react';
import { Image } from '@hz-design-system/web-ui';
import { ImageItemProps } from '../types';
import ListingFavoriteIcon from './ListingFavoriteIcon';
import Classes from './ListingImageItem.module.scss';

const ImageItem: React.FC<ImageItemProps> = ({
  kind,
  image,
  loadingType,
  decodingType,
  fetchPriority,
  children,
  showFavoriteIcon = false,
  isFavorite = false,
  onFavorite,
  descriptionElementId,
  favoriteIconAriaLabel,
  aspectRatio = 'landscape',
  enableLandscapeContain = false,
}) => {
  const containerClass = [
    kind ? Classes[`hz-Listing-image-item--${kind}`] : 'hz-Listing-image-item',
    enableLandscapeContain && image.isLandscape ? Classes['hz-Listing-image-item--landscape-contain'] : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={containerClass}>
      <Image
        title={image.title}
        alt={image.alt}
        src={image.imageSource}
        data-src={image.imageSource}
        loading={loadingType}
        decoding={decodingType}
        fetchpriority={fetchPriority}
        aspectRatio={aspectRatio}
      >
        {showFavoriteIcon ? (
          <ListingFavoriteIcon
            isFavorite={isFavorite}
            onFavorite={onFavorite}
            ariaLabel={favoriteIconAriaLabel}
            descriptionElementId={descriptionElementId}
          />
        ) : undefined}
      </Image>
      {children}
    </div>
  );
};

export default ImageItem;
